exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xs-table-filters {\n  padding: 20px 35px;\n}\n", ""]);

// exports
